<template>

  <div class="chart__canvas">
    <v-chart class="chart__display chart__display--desktop" :option="option" autoresize />
    <v-chart class="chart__display chart__display--mobile" :option="optionMobile" autoresize />
    <div class="chart__details">
      <div class="chart__label">Total Conservative Program Goal</div>
      <div class="chart__value">{{ option.series[0].misc.totalAdjustedImpact }}M<span>MTCO<sub>2</sub>e contained by {{ option.series[0].misc.nearTermEndYear }}</span>
      </div>
    </div>
  </div>

  <div class="chart__info">
    <div class="legend">
      <div class="legend__item legend--header">
        <div class="legend__key"></div>
        <div class="legend__label">Project</div>
        <div class="legend__value">MTCO<sub>2</sub>e</div>
      </div>
      
      <div v-for="(item, index) in option.series[0].data" class="legend__item">
        <div class="legend__key"><span v-bind:style="{'background-color': option.color[index] }"></span></div>
        <div class="legend__label">
          {{ item.name }}
          <span v-if="item.phase === 'experimentation'">Experimentation</span>
        </div>
        <div class="legend__value">
          {{ (item.value).toFixed(1) }}M
        </div>
      </div>
    </div>
  </div>

</template>

<script>

import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { PieChart } from 'echarts/charts';
import VChart from 'vue-echarts';
import { ref, defineComponent } from 'vue';
import chroma from 'chroma-js';

use([
  PieChart,
  CanvasRenderer,
]);

export default defineComponent({
  name: 'DoughnutChart',
  components: {
    VChart
  },
  props: ['id'],
  setup(props) {

    const massageData = []
    let totalImpactAmount = 0;

    (async () => {      try {
        const res = await fetch(`/api/collections/projects/entries`); 
        const { data } = await res.json() 

        const pageData = await fetch(`/api/collections/programs/entries/${props.id}`);
        const otherProgramsAmount = await pageData.json(); 

        const globalData = await fetch(`/api/globals/dataviz`);
        const termEndYear = await globalData.json(); 

        data.forEach(item => {
          if ((item.related_programs.filter(obj => {return obj.id === props.id;})).length > 0){
            massageData.push({
              value: item.project_nearterm_impact_total_adjusted,
              name: item.title,
              label: {show: item.project_nearterm_impact_total_adjusted !== 0},
              phase: item.project_phase.value
            });
            
            totalImpactAmount += item.project_nearterm_impact_total_adjusted;
          }
        });

        massageData.push({
          value: otherProgramsAmount.data.program_other_projects_nearterm_impact_total_adjusted,
          name: 'Other Future Projects',
          label: {show: otherProgramsAmount.data.program_other_projects_nearterm_impact_total_adjusted > 0},
        });

        totalImpactAmount += otherProgramsAmount.data.program_other_projects_nearterm_impact_total_adjusted;

        massageData.sort((a, b) => (a.value < b.value) ? 1 : -1);
        option.value.series[0].data = massageData;
        option.value.color = chroma.scale(['#004D85', '#F6F5F4']).colors(massageData.length);
        option.value.series[0].misc.totalAdjustedImpact = totalImpactAmount;
        option.value.series[0].misc.nearTermEndYear = termEndYear.data.nearterm_end_year;

        optionMobile.value.series[0].data = massageData;
        optionMobile.value.color = chroma.scale(['#004D85', '#F6F5F4']).colors(massageData.length);
        optionMobile.value.series[0].misc.totalAdjustedImpact = totalImpactAmount;
        optionMobile.value.series[0].misc.nearTermEndYear = termEndYear.data.nearterm_end_year;

      } catch (e) { }
    })()

    const option = ref({
      series: [
      {
        type: 'pie',
        label: {
          position: 'inside',
          formatter: function(params){
            let label = (params.value).toFixed(1);
              return `${label}M`
          },
        },
        radius: [150, 300],
        center: ['50%', '50%'],
        color: [],
        data: [],
        misc: {},
      }
    ]
    });

    const optionMobile = ref({
      series: [
      {
        type: 'pie',
        label: {
          position: 'inside',
          formatter: function(params){
            let label = (params.value).toFixed(1);
              return `${label}M`
          },
        },
        emphasis: {
          disabled: true,
        },
        radius: ['45%','100%'],
        center: ['50%', '50%'],
        color: [],
        data: [],
        misc: {},
      }
    ]
    });

    return { option, optionMobile };
  },
})
</script>